module.exports = __webpack_public_path__ + "static/assets/089a8af7b5b6e9490687591efc3f3dd0.svg";